import React from 'react';
import { SearchXIcon, CompassIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function CallOut() {
  return <section className="relative w-full overflow-hidden bg-ink-900 py-10 sm:py-16" data-id="element-18">
      <div className="absolute inset-0 bg-radial-cyan-soft opacity-60" aria-hidden="true" data-id="element-19" />
      <div className="relative mx-auto max-w-3xl px-5" data-id="element-20">
        <SectionHeading eyebrow="El Gancho" data-id="element-21">
          ¿Sientes que el mundo de la IA va a mil por hora y tú te estás
          quedando atrás?
        </SectionHeading>

        <Reveal delay={0.1} className="mt-8 text-base leading-relaxed text-silver/75 sm:text-lg" data-id="element-22">
          <p data-id="element-23">
            Te sientas frente a la pantalla, escribes un prompt genérico y
            recibes una respuesta mediocre que suena a robot. Mientras tanto,
            ves a otros lanzando productos en días, creando anuncios que parecen
            fotografías de alto presupuesto y escalando negocios sin equipo.
          </p>
        </Reveal>

        <Reveal delay={0.2} data-id="element-24">
          <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-25">
            <div className="rounded-2xl border border-white/5 bg-ink-800/60 p-5" data-id="element-26">
              <SearchXIcon className="h-7 w-7 text-urgency" aria-hidden="true" data-id="element-27" />
              <p className="mt-3 text-sm text-silver/80" data-id="element-28">
                Estás tratando a la IA como un{' '}
                <span className="font-semibold text-white" data-id="element-29">buscador</span>…
              </p>
            </div>
            <div className="rounded-2xl border border-accent/30 bg-accent/5 p-5 shadow-glow-cyan" data-id="element-30">
              <CompassIcon className="h-7 w-7 text-accent" aria-hidden="true" data-id="element-31" />
              <p className="mt-3 text-sm text-silver/80" data-id="element-32">
                …cuando deberías tratarla como tu{' '}
                <span className="font-semibold text-accent-light" data-id="element-33">
                  arquitecto de ejecución
                </span>
                .
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.3} data-id="element-34">
          <p className="mt-8 text-center text-lg font-semibold text-white sm:text-xl" data-id="element-35">
            El problema no eres tú.
          </p>
        </Reveal>
      </div>
    </section>;
}